module.exports = __webpack_public_path__ + "img/index10.21a36fee.png";